import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { upload } from '@/services/common';
export default {
  i18n: require('../../design_i18n'),
  props: {
    accept: {
      type: String,
      default: 'application/pdf'
    },
    max: {
      type: Number,
      default: 1
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      uploadLimit: 5,
      fileList: [],
      sizeLimit: '',
      Uploading: false
    };
  },
  created: function created() {
    var arr = [];
    this.list.forEach(function (item, i) {
      if (!item) return;
      arr.push({
        uid: '-' + i,
        name: '' + i,
        status: 'done',
        url: item
      });
    });
    this.fileList = arr;
    this.sizeLimit = localStorage.uploadLimit;
  },
  methods: {
    handleFileRemove: function handleFileRemove(e) {
      var index = 0;
      this.fileList.filter(function (item, i) {
        if (item.uid == e.uid) {
          index = i;
          return true;
        }
        return false;
      });
      this.fileList.splice(index, 1);
      this.$emit('delete');
    },
    // 选择文件后且beforeUpload返回为true后会调用这个方法
    handleUploadChange: function handleUploadChange(_ref) {
      var _this = this;
      var action = _ref.action,
        file = _ref.file,
        onSuccess = _ref.onSuccess,
        onError = _ref.onError,
        onProgress = _ref.onProgress;
      // 这个回调函数的参数是个File对象,所以要用FileReader将对象转换成 data-uri (base64) 对象,才能给vue-cropper
      // var reader = new FileReader();
      // const _this = this;
      // 当文件处理完成的回调函数
      // reader.onload = function(e) {
      // e.target.result 该属性表示目标对象的DataURL
      // 然后调用cropperModal的edit方法使得对话框可见
      // console.log(_this.$refs[`cropperModal${index}`])
      // 	_this.$refs[`cropperModal${index}`][0].edit(e.target.result);
      // };
      // 记录原始的文件名字,用于DataURL(base64)转成file对象,不转就可以不用

      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        // this.tmpImgName = file.name;
        _this.handleOK(fileReader.result, file.name);
      };

      // if (info.file.status === 'done') {
      //
      // 	this.tmpImgName = info.file.name;
      //
      // 	const reader = new FileReader();
      // 	reader.addEventListener('load', () => {
      //
      // 	});
      // 	reader.readAsDataURL(info.file.originFileObj);
      // }

      // 文件处理 file=>base64
      // reader.readAsDataURL(info.file.originFileObj);
    },
    // 然后这里可以调用api请求上传图片
    handleOK: function handleOK(data, name) {
      var _this2 = this;
      var file = this.dataURLtoFile(data, name);

      // ....省略api请求 2种格式的对象都拿到了 怎么请求不用说了吧
      var formData = new FormData();
      formData.append('type', 10);
      formData.append('file', file);
      upload(formData).then(function (result) {
        if (result.data.code == 200) {
          _this2.$message.success(_this2.$t('form.pdfUploadSuccessTip'));
          _this2.Uploading = false;
          var _result$data$data = result.data.data,
            uploadfilepath = _result$data$data.uploadfilepath,
            urlpath = _result$data$data.urlpath;
          var imgPath = uploadfilepath;
          _this2.fileList.push({
            uid: '1',
            name: 'xxxxx',
            status: 'done',
            url: _this2.$store.state.design.imgHost + imgPath
          });
          _this2.$emit('success', imgPath);
          /* this.value[this.curImgItem].path = imgPath */

          //追加列表
          // this.dataForm.specImageList[index].imageList.push({
          //   status: 'done',
          //   productImage: result.data.data.uploadfilepath,
          //   productIndex:this.dataForm.specImageList[index].imageList.length+1
          // });
          //						let rs = result.data.data;
        } else {
          _this2.$message.error(_this2.$t('form.pdfUploadFailTip'));
        }
      }).catch(function (error) {
        _this2.$message.error(_this2.$t('form.pdfUploadFailTip'));
      });
    },
    // 将base64转换为文件 百度随便找的 看需求使用
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    },
    // 对文件格式校验(ant-upload选择文件框是所有类型的)
    beforeUpload: function beforeUpload(file) {
      //				var fileType = file.type;

      //				if(fileType.indexOf('image') < 0) {
      //					this.$message.warning('请上传图片');
      //					return false;
      //				}

      var isPdf = file.type === 'application/pdf';
      if (!isPdf) {
        // this.$message.error(this.$t('public.pictureType'));
        this.$message.error(this.$t('public.pictureType'));
      }
      // const isLt = file.size / 1024 / 1024 < this.uploadLimit;
      // if (!isLt) {
      //   // this.$message.error(this.$t('public.pictureMax',{uploadLimit: this.uploadLimit}));
      //  this.$message.error(this.$t('public.pictureMax',{uploadLimit: this.uploadLimit}))
      // }
      return isPdf;
    },
    handleChange: function handleChange(info) {
      if (info.file.status === 'uploading') {
        this.Uploading = true;
        return;
      }
    }
  }
};